// src/styles/GlobalStyle.js
// 앱 전체에 적용되는 전역 스타일 정의

import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* ===== HTML/Body 기본 설정 (index.css에서 가져옴) ===== */
  
  /* [추가] 전역 CSS 변수 설정 - Safe area 지원 */
  :root {
    /* Safe area 변수 설정 */
    --safe-area-inset-top: env(safe-area-inset-top, 0px);
    --safe-area-inset-right: env(safe-area-inset-right, 0px);
    --safe-area-inset-bottom: env(safe-area-inset-bottom, 0px);
    --safe-area-inset-left: env(safe-area-inset-left, 0px);
    
    /* 동적 뷰포트 높이 */
    --vh: 1vh;
  }
  
  /* [추가] html, body 기본 설정 - 스크롤 문제 해결 */
  html {
    height: 100%;
    overflow-x: hidden; /* 가로 스크롤 방지 */
    /* [추가] 스크롤 동작 부드럽게 */
    scroll-behavior: smooth;
  }

body {
  margin: 0;
  font-family: 'Inter', 'Noto Sans KR', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* 추가: 앱과 동일한 배경 그라데이션 */
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  /* [수정] Pi 브라우저가 아닌 경우 일반 레이아웃 사용 */
  overflow-x: hidden;
  min-height: 100vh;
  /* [추가] 텍스트 선택 시 확대 방지 (iOS) */
  -webkit-touch-callout: none;
}

/* Pi 브라우저에서만 fixed 적용 */
@media screen and (max-width: 9999px) {
  body.pi-browser {
    overflow: hidden !important;
    height: 100vh !important;
    position: fixed !important;
    width: 100% !important;
  }
}

  /* ===== Root 설정 (index.css + App.css에서 가져옴) ===== */
  
  /* [추가] root 엘리먼트 설정 */
#root {
  /* [수정] 스크롤 문제 해결 */
  height: 100vh !important;
  overflow-y: auto !important;
  -webkit-overflow-scrolling: touch;
  position: relative;
  /* [추가] overflow 제어 */
  overflow-x: hidden;
  /* [추가] 플렉스 컨테이너로 설정 */
  display: flex;
  flex-direction: column;
  
  /* App.css에서 가져온 모바일 세로형 화면 최적화 */
  max-width: ${props => props.theme.layout.maxWidth};
  margin: 0 auto;
  background-color: #34495e; /* 배경색 통일 */
}

  /* ===== 데스크톱 환경 설정 (App.css에서 가져옴) ===== */
  
  /* 데스크톱에서 모바일 화면처럼 보이도록 */
  @media (min-width: 451px) {
    body {

    }
    
    #root {
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    }
  }

  /* ===== 기본 요소 스타일 (index.css에서 가져옴) ===== */
  
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  /* [추가] 모바일에서 탭 하이라이트 제거 */
  * {
    -webkit-tap-highlight-color: transparent;
  }

  /* ===== 스크롤바 스타일링 (index.css에서 가져옴) ===== */
  
  /* [추가] 스크롤바 스타일링 (선택사항) */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.5);
  }

  /* ===== 공통 애니메이션 정의 ===== */
  
  /* theme.js의 애니메이션을 전역으로 사용 가능하도록 추가 */
  ${props => props.theme.animations.fadeIn}
  ${props => props.theme.animations.popIn}
  ${props => props.theme.animations.pulse}
  ${props => props.theme.animations.shine}
  ${props => props.theme.animations.float}
  ${props => props.theme.animations.bounce}
  ${props => props.theme.animations.sparkle}
  ${props => props.theme.animations.spin}
  ${props => props.theme.animations.shimmer}
  ${props => props.theme.animations.gradient}
  
  /* ===== 추가 전역 스타일 ===== */
  
  /* 모든 박스 사이징을 border-box로 통일 */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  /* 이미지 기본 설정 */
  img {
    max-width: 100%;
    height: auto;
  }

  /* 버튼 기본 스타일 리셋 */
  button {
    font-family: inherit;
  }

  /* 링크 기본 스타일 */
  a {
    color: inherit;
    text-decoration: none;
  }

  /* Portal Root (모달 등을 위한 컨테이너) */
  #portal-root {
    position: relative;
    z-index: ${props => props.theme.zIndex.modal};
  }
  
  /* [추가] Safe area를 고려한 기본 패딩 */
  .safe-area-top {
    padding-top: env(safe-area-inset-top);
  }
  
  .safe-area-bottom {
    padding-bottom: env(safe-area-inset-bottom);
  }
  
  .safe-area-left {
    padding-left: env(safe-area-inset-left);
  }
  
  .safe-area-right {
    padding-right: env(safe-area-inset-right);
  }
  
  /* [추가] Pi 브라우저 전용 스타일 */
  .pi-browser {
    /* Pi 브라우저에서 필요한 특별한 스타일 */
  }
`;

export default GlobalStyle;